import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

// DESIGN.md components: button-primary, button-primary-hover, button-secondary.
// Flat, mono labels, small radius. One primary action per screen.
const buttonVariants = cva(
  "ease inline-flex items-center justify-center gap-zsd-sm whitespace-nowrap select-none cursor-pointer no-underline " +
    "rounded-zsd-sm h-zsd-control-height px-zsd-lg font-zsd-label-lg text-zsd-label-lg " +
    "disabled:cursor-progress disabled:opacity-70 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "bg-zsd-primary text-zsd-on-primary hover:bg-zsd-primary-hover",
        secondary: "control-border bg-zsd-surface-raised text-zsd-on-surface-raised hover:border-zsd-primary",
        ghost: "px-zsd-sm text-zsd-on-surface underline hover:text-zsd-primary",
      },
      width: {
        auto: "",
        full: "w-full",
      },
    },
    defaultVariants: {
      variant: "primary",
      width: "auto",
    },
  },
);

function Button({
  className,
  variant,
  width,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";
  return <Comp data-slot="button" className={cn(buttonVariants({ variant, width, className }))} {...props} />;
}

export { Button, buttonVariants };
